import { Card } from "@endya-conformite/ui-kit";
import { PrismicText } from "@prismicio/react";
import LightBulb from "@endya-conformite/ui-kit/src/assets/icons/lightbulb.svg?react";
import { PrismicDocument } from "@prismicio/client";
import classNames from "classnames";
import styles from "./LeSaviezVous.module.scss";
import { PrismicLeSaviezVous } from "./useLeSaviezVous";

type LeSaviezVousItemProps = {
  title: JSX.Element | null;
  description: JSX.Element | null;
  small?: boolean;
};
export function LeSaviezVousItem({
  title,
  description,
  small = false,
}: LeSaviezVousItemProps) {
  return (
    <Card
      className={classNames(styles.leSaviezVous, {
        [styles.small]: small,
      })}
    >
      <LightBulb className={styles.icon} />
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{description}</p>
    </Card>
  );
}
type LeSaviezVousListProps = {
  leSaviezVous: PrismicDocument<PrismicLeSaviezVous, string, string>[];
};
export function LeSaviezVousList({ leSaviezVous }: LeSaviezVousListProps) {
  return (
    <div className={styles.leSaviezVousList}>
      {leSaviezVous?.map((doc) => (
        <LeSaviezVousItem
          key={doc.id}
          title={<PrismicText field={doc.data.title} />}
          description={<PrismicText field={doc.data.description} />}
        />
      ))}
    </div>
  );
}
